import React from 'react';
import { useTranslation } from 'react-i18next';

export const StapLabels: React.FC = () => {
  const { t } = useTranslation();
  const labels = t('overview.ratings.stapLabels', {
    returnObjects: true,
  }) as string[];

  return (
    <>
      {labels.map((label, index) => (
        <span
          key={label}
          style={{ left: `${(index + 1) * 25}%` }}
          className="absolute -translate-x-1/2"
        >
          {label}
        </span>
      ))}
    </>
  );
};
